import { render, staticRenderFns } from "./settings-user-ai-card.vue?vue&type=template&id=374ec954"
import script from "./settings-user-ai-card.vue?vue&type=script&lang=js"
export * from "./settings-user-ai-card.vue?vue&type=script&lang=js"
import style0 from "./settings-user-ai-card.vue?vue&type=style&index=0&id=374ec954&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports